import router from '@/router';
import axios from 'axios';
import cookies from 'vue-cookies';

/*
 * Create an Instance
 */

const API = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + '/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const APIToken = function() {
  const token = cookies.get('templeFrontStageApiToken');
  return axios.create({
    baseURL: process.env.VUE_APP_BASE_API + '/api',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};

/*
 * Interceptor
 */

API.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

/*
 * Response Handler
 */

const responseHandler = {
  '200': (response) => {
    return Promise.resolve(response);
  },
  '422': (response) => {
    return Promise.reject(response.data.errors);
  },
  '400': (response) => {
    response.data.title = '該文章已被下架';
    response.data.name = '該文章已被下架';
    return Promise.resolve(response);
  },
  '401': (response) => {
    // message: "Unauthenticated."
    return Promise.reject(response);
  },
  '404': (response) => {
    router.push({ name: 'PageNotFound' });
    return Promise.reject(response);
  },
};

/*
 * Methods
 */
const GET = (url, params) => {
  return API.get(url, {
    params: params || '',
  })
    .catch((response) => response.response)
    .then((response) => responseHandler[response.status](response));
};

const GET_TOKEN = (url, params) => {
  return APIToken()
    .get(url, {
      params: params || '',
    })
    .catch((response) => response.response)
    .then((response) => responseHandler[response.status](response));
};

const POST = (url, data) => {
  return API.post(url, data)
    .catch((response) => response.response)
    .then((response) => responseHandler[response.status](response));
};

const POST_TOKEN = (url, data) => {
  return APIToken()
    .post(url, data)
    .catch((response) => response.response)
    .then((response) => responseHandler[response.status](response));
};

const DELETE = (url, params) => {
  return APIToken()
    .delete(url, {
      params: params || '',
    })
    .catch((response) => response.response)
    .then((response) => responseHandler[response.status](response));
};

export { GET, GET_TOKEN, POST, POST_TOKEN, DELETE };
